import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { ColorRGB } from '../../utils/GlobalHelper';
import { ProjectSettingsActions } from '../../actions/ProjectSettingsActions';
import { CoreColorPicker } from '../CoreColorPicker';
import { PopupMenu } from '../../constants/Enums';
import { VisibilityActions } from '../../actions/VisibilityActions';
import { ProjectSettingsStore } from '../../stores/ProjectSettingsStore';

interface SolidFloorSetupProps {
    layoutType: LayoutType;
}

export class SolidFloorSetup extends BaseComponent<SolidFloorSetupProps, {}> {
    public render(): JSX.Element {
        return (
            <div className="floorplan-setup">
                <div className="egr-select-option-header">
                    <span>{t('Workspace')}</span>
                    <div className="floorplan-setup-close sprite-icon-close" onClick={this.onCloseClick}/>
                </div>
                <div className="floorplan-setup-content">
                    <CoreColorPicker
                        height={100}
                        widthPan={180}
                        spaceWidth={12}
                        widthSlider={18}
                        initialValue={ProjectSettingsStore.getState().groundColor}
                        onChange={this.setColor}
                        defaultColors={[
                            {r: 246, g: 240, b: 225},
                            {r: 226, g: 218, b: 207},
                            {r: 97, g: 67, b: 34},
                            {r: 104, g: 119, b: 148},
                            {r: 79, g: 79, b: 79},
                            {r: 178, g: 178, b: 178},
                            ProjectSettingsStore.defaultGroundColor,
                        ]}
                    />
                </div>
            </div>
        );
    }

    protected onCloseClick(): void {
        VisibilityActions.setPopupMenu(PopupMenu.NONE);
    }

    protected setColor(value: ColorRGB | null): void {
        ProjectSettingsActions.setGroundColor(value);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/SolidFloorSetup.tsx